import styles from "./Product.module.css";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import States from "./States";
import Header from "./Header";
import Footer from "./Footer";
import {useRefAgent} from "../hooks/useRefAgent";
import { UseClearAgent } from "../manager/SearchParam";
import {usePincodeSearch} from "../hooks/usePincodeFinder";
import {useImagePreview} from "../hooks/useImagePreview";
import {ImagePreview} from "../components/ImagePreview";
import DOMPurify from "dompurify";
import Config from "./Config";


function Product() {
  const navigate = useNavigate();
  const {productId} = useParams();
  const clearAgent = UseClearAgent();
  const [searchParams, setSearchParams] = useSearchParams();
  const Pincode = "682001";

  let agent_name = "";
  let Check_pincode = "";
  let Item_title = "";
  let Item_brand = "";
  let Item_description = "";
  let Page_title = "";
  let Page_description = "";
  let Item_availability = 0;
  let Item_canexpire = false;
  let Item_expiry = null;
  let Item_created = null;
  let Item_id = "";
  let MRP_price = 0;
  let Price_price = 0;
  let Agent_price = 0;
  let Delivery_unit_price = 70;
  const Interstate_delivery_charge = useRef(0);
  let image_url = "/images/no_image.png";
  let image_original = null;
  const [Product, setProduct] = useState();
  const [variant, setVariant] = useState(null);
  const [itemExpiry, setItemExpiry] = useState(0);
  const {Ref, Agent, RefreshAgent} = useRefAgent();
  const [Loading, setLoading] = useState(false);
  const [Item_in_cart, setItem_in_cart] = useState(false);
  const [Thumbnail, setThumbnail] = useState(false);
  const [Refresh, setRefresh] = useState(0);

  const {fullScreen, openPreview, closePreview} = useImagePreview();

  const [Pin, setPin] = useState(sessionStorage.getItem("pin") || Pincode);
  const [ExPin, setExPin] = useState("");
  const {PincodeFound, PincodeState, PinSearchLoading} = usePincodeSearch(Pin);
  const [Pincode_alert, setPincode_alert] = useState(Check_pincode);
  const [Available, setAvailable] = useState(false);
  
  const cartID = crypto.randomUUID();
  const [Cart, setCart] = useState(localStorage.getItem("cart")?JSON.parse(localStorage.getItem("cart")) : {id: cartID, items: []});

  useEffect(()=>{
    if(PinSearchLoading) return;
    if(PincodeState) sessionStorage.setItem("state", PincodeState);
    if(PincodeFound || Agent) {
      setPincode_alert("Delivery is available for selected Pincode!");
      setAvailable(true);
    }
    else{
      setPincode_alert("Delivery not available for selected Pincode!");
      setAvailable(false);
    }
  }, [PincodeFound, PinSearchLoading, PincodeState, Agent]);

  useEffect(()=>{
    const loading = document.getElementById("loading");
    if(Loading) {
      return loading.classList.add(styles.incomplete);
    }
    loading.classList.remove(styles.incomplete);
  }, [Loading]);
  useEffect(()=>{
    const loading = document.getElementById("loading");
    if(!Product) {
      return loading.classList.remove(styles.complete);
    }
    loading.classList.add(styles.complete);

  },[Product]);

  useEffect(()=>{
    const pin = ExPin;
    if(pin?.length!==6 || pin === Pin || Agent) return;
    setPin(pin);
  }, [ExPin, Pin, Agent]);

  useEffect(()=>{
    if(!productId) return;
    const fetchItem = async () =>{
      setItem_in_cart(false);
      try{
        const res = await fetch(Config.NodePath+`/api/products/${productId}`, {credentials: "include"});
        if(res.ok) {
          const result = await res.json();
          setProduct(result);
          setLoading(false);
          
          
        }
        else if(res.status===401 && Refresh===0) {
          setRefresh(prev=>prev+1);
        }
      }
      catch(err) {
        console.log(err);
      }
    }
    fetchItem();
  },[productId, Refresh]);

  useEffect(()=>{
    if(!Product) return;

    const urlVariant = searchParams.get("variant");
    if(urlVariant) {
      const found = Product.variants.find(v=>v._id === urlVariant);
      if(found) {
        setVariant(found);
        return;
      }
    }

    if(Product.variants.length>0) {
      const firstAvailable = Product.variants.find(v=> v.availability !== 0);
      setVariant(firstAvailable || Product.variants[0]);
    }
  }, [Product, searchParams]);

  useEffect(()=>{
    setLoading(true);
    if(!variant) return;
    setLoading(false);

    const currentParam = searchParams.get("variant");
    if(currentParam !== variant._id) {
      setSearchParams(prev=>{
        const newParams = new URLSearchParams(prev);
        newParams.set("variant", variant._id);
        return newParams;
      });
    }
  }, [variant, searchParams, setSearchParams]);
  
  if(Agent) {
    const match = Agent;
    if(match) {
      agent_name = match.name;
    }
  }
  if(productId) {
    const match = Product&&variant?variant:null;
    if(match) {
      Item_id = Product._id;
      Item_brand = Product.brand;
      Item_title = Product.title;
      Page_title = Item_title+" - "+Item_brand+" | "+Config.siteName;
      Item_description = Product.description;
      Page_description = Item_description.slice(0,160).trim()+"...";
      MRP_price = match.MRP;
      Price_price = match.price;
      Agent_price = match.agent;
      Delivery_unit_price = match.delivery;
      Item_availability = match.availability === 0 || match.stock <= 0 ? 0 : 1;
      Item_canexpire = match.canExpire;
      Item_expiry = new Date(match.expiresAt).getTime();
      Item_created = new Date(match.publishDate).getTime();
      const images = match.image;
      if(images) {
        image_url = images;
      }
      if(match.image) image_original = match.image;
    }
  }

  useEffect(()=>{
    if(sessionStorage.getItem("state")) {
      const getState = sessionStorage.getItem("state");
      const match = States.find(location=>location.state.toLowerCase()===getState?.toLowerCase());
      if(match && !Agent) {
        if(Delivery_unit_price>0) {
          Interstate_delivery_charge.current = match.charge;
        }
      }
    }
  }, [Agent, Delivery_unit_price]);

  const updatePin = () =>{
    let pin = document.getElementById("changedPin");
    const checkNumber = /^\d+$/.test(pin.value);
    if(checkNumber && pin.value.length===6) {
      if(Pin !== pin.value) {
        setExPin(pin.value);
        sessionStorage.setItem("pin", pin.value);
      }
      document.getElementById("changePincode").classList.remove(styles.show);
    }
    else{
      alert("Please Enter a valid Pincode!");
      pin.focus();
    }
  }
  const refreshAgent = (x) =>{
    const cancelAgent = document.getElementById("cancelAgent");
    if(cancelAgent) {
      if(x===0) cancelAgent.classList.add(styles.open);
      if(x===2) cancelAgent.classList.remove(styles.open);
      if(x===1) {
        clearAgent();
        RefreshAgent();
      }
    }
    
  }
  const pincodeAlert_id = document.getElementById("pincodeAlert");

  let Discounted_unit_price = Price_price;
  let Discount_C = Math.floor((MRP_price - Discounted_unit_price)/(MRP_price/100));
  let AgentDiscount_C = Math.floor((MRP_price - Agent_price)/(MRP_price/100));

  if(Agent || Ref) {
    Discounted_unit_price = Agent_price;
    Discount_C = AgentDiscount_C;
  }

  useEffect(()=>{
    const meta = document.querySelector('meta[name="description"]');
    if(meta) {
      meta.setAttribute("content", Page_description!==""?Page_description:"Products page");
    }
    document.title = Page_title!==""?Page_title:Config.siteName;
  }, [Page_description, Page_title]);

  const checkThumbnail = useCallback(()=>{
    setThumbnail(true);
  }, []);
  const changePincode = () => {
    if(Agent) return alert("Cancel Agent to change Pincode!");
    document.getElementById("changePincode").classList.add(styles.show);
  }
  const changePincode_close = () => {
    document.getElementById("changePincode").classList.remove(styles.show);
  }

  let Item_buy_button = (<><button className={styles.buyB} id="buyButton" onClick={()=>BuyItem(Item_id, variant._id)}>Buy Now</button></>);
  let Change_pin_button = (<><button type="button" title="Change pincode" onClick={changePincode}>{PinSearchLoading?"Checking.." : "Change"}</button></>);
  

  const LoadingPage = (
    <><div id="loading" className={`${styles.loading}`}><div className={styles.loader}></div></div></>
  );
  if(Item_availability === 0) {
    Item_buy_button = (<button className={styles.buyB} disabled>Out of stock</button>);
  }
  
  if(Product && pincodeAlert_id) {
    if(Available && (PincodeFound || Agent)) {
          pincodeAlert_id.classList.remove(styles.red);
          pincodeAlert_id.classList.add(styles.green);
      }
    else{
          pincodeAlert_id.classList.remove(styles.green);
          pincodeAlert_id.classList.add(styles.red);
    }
  }
  useEffect(()=>{
    if(Cart && variant) {
      const searchCart = Cart.items?.find(item=>item.vid === variant._id);
      if(searchCart) {
        setItem_in_cart(true);
      }
      else{
        setItem_in_cart(false);
      }
    }
  }, [Cart, variant]);

  useEffect(()=> {
    if(!Item_canexpire || !Item_expiry || !Item_created) return;

    const updateExpiry = () =>{
      let remaining = Item_expiry - Date.now();
      if(Item_created > Date.now()) {
        remaining = Item_created - Date.now();
      }
      if(remaining <= 0) {
        setItemExpiry(0);
        return false;
      }

      setItemExpiry(remaining);
      return true;
    }

    if(!updateExpiry()) return;

    const timer = setInterval(() => {
      if(!updateExpiry()) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [Item_canexpire, Item_expiry, Item_created]);

  let productExpiryTimer = "00:00:00";
  let productExpiryTimerSimple = "00:00:00";
  if(Item_canexpire && Item_expiry > 0) {
    const totalSeconds = itemExpiry / 1000;
    const days = Math.floor(totalSeconds/86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    productExpiryTimer = `${days > 0 ? String(days).padStart(2,"0")+"d" : ""} ${String(hours).padStart(2, "0")+"h"} ${String(minutes).padStart(2, "0")+"m"} ${String(seconds).padStart(2, "0")+"s"}`;
    productExpiryTimerSimple = days > 0 ? String(days)+" days" : hours > 0 ? String(hours)+" hours" : minutes > 0 ? String(minutes)+" minutes" : String(seconds)+" seconds";
  }

  if(Item_created > Date.now() && Item_canexpire) {
    Item_buy_button = (<button className={styles.buyB} disabled>Available in {productExpiryTimerSimple}</button>);
  }
  else if(Item_expiry < Date.now() && Item_canexpire) {
    Item_buy_button = (<button className={styles.buyB} disabled>Unavailable</button>);
  }

  const BuyItem = (id, vid)=>{
    try{
      if(!Item_in_cart) {
        Addtocart(id, vid);
      }
      navigate("/my-cart");
    }
    catch(err) {
      console.log(err);
    }
  }
  const Addtocart = (id, vid)=>{
    if(!id || !vid) return;
    if(!Cart?.items) return;

    const existing = Cart.items.some(item=>item.vid===vid);
    const updatedItems = existing?Cart.items.filter(item=>item.vid !== vid): [...Cart.items, {id, vid, qty: 1}];
    const updatedCart = {...Cart, items: updatedItems};

    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setCart(updatedCart);
  }
  
  const productImage = (
    <>
    <div className={styles.productImage}>
      <img src={image_url} onClick={()=>{if(image_original){openPreview(image_original)}}} alt="" style={{opacity:Thumbnail?1:0}} onLoad={checkThumbnail} />
      
    </div>
    </>
  );// Product Image
  const navigation = (
    <>
    <div className={styles.productNavigation}><a href="/" title="back">❮ Back</a></div>
    </>
  );// navigation, back button
  const productPrice = (
    <>
    <div className={styles.price_tag}>₹ {Math.ceil(Discounted_unit_price)}/- <span className={styles.discount}>{Discount_C>0?`${Discount_C}% off `:""}</span> <span className={styles.mrp}>{Discounted_unit_price!==MRP_price?`( MRP: ₹${MRP_price}/- )`:""}</span></div>
    </>
  );//End Product Price
  const productCartButton = (
    <div className={styles.cartButton}>
    
    </div>
  );
  const productBuyButton = (
    <div className={styles.buyButton}>
      {Item_buy_button}
      {Item_availability===1 && ((Item_expiry > Date.now() && Item_created < Date.now()) || !Item_canexpire)?(
        <button className={`${styles.cartB} ${Item_in_cart?styles.cartB2:""}`} onClick={()=>Addtocart(Item_id, variant._id)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" viewBox="0 0 16 16">
  <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l1.313 7h8.17l1.313-7zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
</svg> {Item_in_cart?"Remove": "Add to cart"}
      </button>
      ):""}
    </div>
  );// Buy button
  const productVariant = (
    <div className={styles.item_variant}>
      {Product&&variant?Product.variants.map((item,index)=> {
        const variant_id = item._id;
        let variant_unit = item.measurement.value+" "+item.measurement.unit;
        let variant_packaging = item.packaging;
        const variant_availability = item.availability;
        if(item.canExpire && Product.isPeriodic) {
          const publishDate = new Date(item.publishDate);
          variant_packaging = "";
          variant_unit = publishDate.toLocaleDateString("en-US",{
            month: "long",
            day: "numeric"
          })
        }
        if(variant_id === variant._id) {
          return (<button className={styles.item_variant_active} key={index}>{variant_unit+" "+variant_packaging}</button>);
        }
        if(variant_availability===0) {
          return (<button key={index} title={`${variant_unit} ${variant_packaging} Out of stock`} className={styles.disabled_button}>{variant_unit+" "+variant_packaging}</button>);
        }
        return (<button className={styles.item_variant_link} key={index} title={`${variant_unit} ${variant_packaging} Available Here`} onClick={()=>{setThumbnail(false); setVariant(item)}}>{variant_unit+" "+variant_packaging}</button>);
        }):""}
    </div>
  );// Product Variant
  const productExpiry = (
    <div className={styles.productExpiry}>
      {itemExpiry > 0 && Item_created > Date.now()? `Sale starts in: ${productExpiryTimer}` : itemExpiry > 0 ? `Sale ends in: ${productExpiryTimer}`: "This sale has ended. Stay tuned for our next promotion."}
    </div>
  );// product Expiry
  const productTitle = (
    <div className={styles.productTitle}>
      &#91; {Item_id} &#93;
      <h2>{Item_title}</h2>
    </div>
  );// Product Title
  const productDeliveryCharge = (
    <div className={styles.productDeliveryCharge}>
      * {Delivery_unit_price===0? " Free Delivery 💚": Agent?"Free delivery on orders above ₹"+Config.minCartValue: "Delivery charge may apply"}
    </div>
  );
  const productDescription = (
    <>
    <div className={styles.productDescription}>
      <h3>Description</h3>
        <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(Item_description || "", {ALLOWED_TAGS: ["p", "strong", "em", "ul", "ol", "li", "br", "h1", "h2", "h3"],})}}></div>
      </div>
    </>
  );// Product Description
  const pincodeCheck = (
    <>
    <div className={styles.changePincode} id="changePincode">
      <div className={styles.changePincodeBox}>
          <input type="text" inputMode="numeric" name="changedPin" id="changedPin" />
        <button className={styles.update} title="Update pincode" onClick={updatePin}>Update</button><button className={styles.close} title="Cancel" onClick={changePincode_close}>X</button><br />
        <span>Please Enter your Pincode here to check availability</span>
      </div>
    </div>
    <div className={styles.pincode}>
      <label>{Agent?Agent.state : PincodeState?`(${PincodeState}) - `:""} Pincode: {Agent?Agent.pincode:Pin}
      </label>
      {Change_pin_button}
    </div>
    <div id="pincodeAlert" className={styles.pincodeAlert}>{Pincode_alert}</div>
    </>
  );//End Pincode Check
  const mainContent = (
    <>
      {!Agent?"":(
        <div className={styles.message}>
          <div id="cancelAgent" className={styles.confirmation}>
            <div>Wait - you'll lose a special discount worth ₹{Price_price-Agent_price} + free shipping. Continue?</div>
            <div><button onClick={()=>refreshAgent(1)}>Yes</button><button onClick={()=>refreshAgent(2)}>No</button></div>
            
          </div>
          <span>Agent <b>{agent_name}</b> will handle this delivery. Please make sure you are within the serviceable pincode area ({Agent?Agent.pincode:Pin}). click below to cancel the agent.</span>
          <button onClick={()=>refreshAgent(0)}>Cancel Agent</button>
        </div>
      )}
    </>
  );
  const mainRender = (
    <>
    {navigation}
    {productImage}
    {productTitle}
    {productPrice}
    {productVariant}
    {Item_canexpire?productExpiry:""}
    {productBuyButton}
    {productCartButton}
    {mainContent}
    {Config.pincodeValidation&&Config.checkState?pincodeCheck:""}
    {productDescription}
    {productDeliveryCharge}
    
    </>
  );
  return(
    <>
    {<Header />}
    <div id="fullWrapper" className={`${styles.full_wrapper}`}>
      {LoadingPage}
      {Product?mainRender:""}
    </div>
    {<ImagePreview fullScreen={fullScreen} onClose={closePreview} />}
    {<Footer />}
    </>
  );
}
export default Product;
